module.exports = __webpack_public_path__ + "static/media/gains-logo-dark.6f623fc0.svg";